import { render } from "./ProjectsTable.vue?vue&type=template&id=0d0a3538&scoped=true"
import script from "./ProjectsTable.vue?vue&type=script&lang=js"
export * from "./ProjectsTable.vue?vue&type=script&lang=js"

import "./ProjectsTable.vue?vue&type=style&index=0&id=0d0a3538&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0a3538"]])

export default __exports__